import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const VideoRecorderIcon = (props: IconPropsType) => {
   const {
      fill = colors['violet-600'],
      width = 24,
      height = 24,
      ...rest
   } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         fill='none'
         viewBox='0 0 24 24'
         {...rest}
      >
         <path
            fill={fill}
            fillRule='evenodd'
            d='M12.241 4H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 8.29 1 8.954 1 9.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 20 5.954 20 6.758 20h5.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.04-.502.044-1.11.044-1.838l1.953 1.954c.192.19.38.379.544.517.147.123.457.37.885.403a1.5 1.5 0 0 0 1.259-.521c.279-.327.323-.72.34-.911.02-.214.019-.48.019-.75V8.894c0-.27 0-.536-.019-.75-.017-.19-.061-.584-.34-.911a1.5 1.5 0 0 0-1.259-.521c-.428.033-.738.28-.885.403a9.152 9.152 0 0 0-.543.517L18 9.586c0-.728-.003-1.336-.044-1.838-.046-.562-.145-1.079-.392-1.564a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C13.71 4 13.046 4 12.242 4Z'
            clipRule='evenodd'
         />
      </svg>
   )
}

export default VideoRecorderIcon
